export default __webpack_public_path__ + "static/media/EAP-Icon-2.5bbd5ae5.svg";